import { render } from "./GoogleSignOn.vue?vue&type=template&id=156c198b"
import script from "./GoogleSignOn.vue?vue&type=script&lang=js"
export * from "./GoogleSignOn.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__